import { Button } from 'components/atoms';
import SubtitlesCard from 'components/molecules/card/subtitles/SubtitlesCard';
import ListWrapper from 'components/molecules/list-wrapper/ListWrapper';
import { useFormikContext } from 'formik';
import { IFormikContextType } from 'hooks/useFormikField';
import { useTranslation } from 'react-i18next';
import { PiPlus } from 'react-icons/pi';
import { IVideoMutationForm } from 'services/video/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';

const VideoSubtitles = () => {
  const { values, status, setFieldValue }: IFormikContextType<IVideoMutationForm> =
    useFormikContext<IVideoMutationForm>();
  const { t } = useTranslation();

  const handleToggleInstrumental = async () => {
    if (!isInstrumental) {
      await setFieldValue('subtitles', []);
    }
  };

  const handleAddSubtitle = () => {
    setFieldValue('subtitles', [
      {
        id: values.subtitles.length,
        language: -1,
        title: '',
        version: '',
      },
      ...values.subtitles,
    ]);
  };

  const isInstrumental = !!values.isInstrumental;
  return (
    <div className="flex flex-col w-full gap-4">
      {!status?.displayMode && (
        <Button fullWidth variant={BUTTON_VARIANT.white} onClick={handleAddSubtitle}>
          <Button.Icon icon={<PiPlus />} />
          <Button.Text text={t('button.add')} />
        </Button>
      )}

      <ListWrapper
        isLoading={status?.isLoading}
        items={values.subtitles}
        item={(subtitle, index) => (
          <SubtitlesCard
            key={index}
            index={index}
            subtitle={subtitle}
            displayMode={status?.displayMode}
            onRemove={() =>
              setFieldValue(
                'subtitles',
                values.subtitles.filter((_, titleIndex) => index !== titleIndex),
              )
            }
          />
        )}
      />
    </div>
  );
};

export default VideoSubtitles;
